import React, {useEffect, useMemo, useRef, useState} from 'react'
import styles from './FourthStep.module.css'
import {ProjectAnalysis} from 'modules/projects/models/Project'
//@ts-ignore
import igv from '../../../node_modules/igv/dist/igv.esm'
import {Individual} from 'modules/individuals/models/Individual'
import {getIndividualContainer} from 'container/individual-module'
import {IndividualService} from 'modules/individuals/services/IndividualService'
import {INDIVIDUAL_SERVICE_KEY} from 'modules/individuals'
import {Query, QueryParam} from 'common/api/Query'
import {Embryo, EmbryoDTO, toModel} from "../../modules/embryos/models/Embryo";
import {EMBRYO_SERVICE_KEY} from "../../modules/embryos";
import {EmbryoService} from "../../modules/embryos/services/EmbryoService";
import {getEmbryoContainer} from "../../container/embryo-module";
import { MutationsPosition } from 'modules/mutationsPosition/models/MutationsPosition'
import { useTranslation } from 'react-i18next'
import { Field} from 'components/table'
import { TableContainer, TableRow, TableCell,  Button, MenuItem, Select, Grid, Menu, InputLabel, FormControl, Typography } from '@material-ui/core'
import { Body } from 'components/table/Body'
import { Head } from 'components/table/Head'
import { Table } from '@material-ui/core'
import { individualsTitle } from 'modules/individuals/enums/Individuals'
import { commonStyles } from 'common/styles/Styles'
import { Status, DirectTestingStatus, statusTitle, directTestingStatusTitle} from '../../modules/individuals/enums/Status'
import { getDirectTestingContainer } from 'container/directTesting-module'
import { DIRECT_TESTING_SERVICE_KEY } from 'modules/directTesting'
import { DirectTestingService } from 'modules/directTesting/services/DirectTestingService'
import { DirectTesting } from 'modules/directTesting/models/DirectTesting'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'



const individualService = getIndividualContainer().get<IndividualService>(INDIVIDUAL_SERVICE_KEY)
const embryoService = getEmbryoContainer().get<EmbryoService>(EMBRYO_SERVICE_KEY)
const directDetectionService = getDirectTestingContainer().get<DirectTestingService>(DIRECT_TESTING_SERVICE_KEY)


type SecondStepProps = {
    increaseStep?: () => void
    deleteFiles?: () => void
    decreaseStep?: () => void
    project?: ProjectAnalysis
    individuals?: Individual[]
    embryos?: EmbryoDTO[]
    variants?: MutationsPosition[]
    setViewIGV: (b: boolean) => void
    externalLocus?: string
    hideControls?: boolean
    step: number
}

type IndividualFiles = {
    individual?: Individual
    baiID: string
    bimID: string
    embryo?: Embryo
}

export const IGV = (props: SecondStepProps) => {
    const directTestingOptions = [DirectTestingStatus.NonCarrier, DirectTestingStatus.Carrier, DirectTestingStatus.Affected, DirectTestingStatus.Inconclusive]
    const igvDivRef = useRef(null)
    const igvBrowserRef = useRef<any>(null)
    const [individuals, setIndividuals] = useState<Individual[]>([])
    const [individualsDir, setIndividualsDir] = useState<DirectTesting[]>([])
    const [embryos, setEmbryos] = useState<EmbryoDTO[]>([])
    const [variants, ] = useState<MutationsPosition[]>(props.variants || [])
    const [mapIndividualFiles, setMapIndividualFiles] = useState<IndividualFiles[]>([])
    const [selectedVariant, setSelectedVarinat] = useState<MutationsPosition>()
    const [isLoaded, setIsLoaded] = useState<Boolean>(false)
    const [isLoadedIndi, setIsLoadedIndi] = useState<Boolean>(false)
    const [isLoadedEmb, setIsLoadedEmb] = useState<Boolean>(false)
    const [locus, setLocus] = useState<string>('')
    const [url, setUrl] = useState<string>()
    const styles2 = commonStyles()
    const [isBoth, setIsBoth] = useState<boolean>()
    
    
    const {t} = useTranslation()
    
    const fields: Field<any>[] = [
        {
            sortable: false,
            searchable: false,
            label: t('individual'),
            name: 'individual',
        },
        {
            sortable: false,
            searchable: false,
            label: t('fileName'),
            name: 'fileName',
        },
        {
            sortable: false,
            searchable: false,
            label: t('status'),
            name: 'status',
        },
        {
            sortable: false,
            searchable: false,
            label: t('Direct testing'),
            name: 'DirectTesting',
            
        },

    ]

    const fields2: Field<any>[] = [
        {
            sortable: false,
            searchable: false,
            label: t('embryo'),
            name: 'embryo',
        },
        {
            sortable: false,
            searchable: false,
            label: t('fileName'),
            name: 'fileName',
        },
        {
            sortable: false,
            searchable: false,
            label: t('Direct testing'),
            name: 'DirectTesting',
            
        },

    ]


    const Order: Record<string, number> = {
          mother: 0,
          father: 1,
    }
    useEffect(() => {
        if(props?.embryos){
            setEmbryos(props?.embryos);
        }
    }, [props.embryos]);

    useEffect(() => {
        let iFilesArray: IndividualFiles[] = []
        setUrl(process.env.REACT_APP_BACKEND_URL)
        setIndividuals(props?.individuals || [])
        // Cargar individuos
        individualService
            .getFilteredList(
                new Query({
                    query: [new QueryParam('informativityID', props.project?.informativityID || '')],
                })
            )
            .subscribe((res) => {
                setIndividuals(res.items)
                res.items.forEach((individual) => {
                    let ifiles: IndividualFiles = {
                        individual: individual,
                        baiID: individual.baiFileID,
                        bimID: individual.bimFileID
                    }
                    if (ifiles.baiID !== "" && ifiles.bimID !== "") {
                        iFilesArray.push(ifiles)
                    }

                })
                setIsLoadedIndi(true)
            })

        // Cargar embriones
        embryoService.getFilteredList(new Query({query: [new QueryParam('embryosGroupID', props.project?.embryosGroupID || '')]})).subscribe((res) => {
            res.items.forEach((embryo) => {
                let ifiles: IndividualFiles = {
                    baiID: embryo.baiFileID,
                    bimID: embryo.bimFileID,
                    embryo: toModel(embryo)
                }
                if (ifiles.baiID !== "" && ifiles.bimID !== "") {
                    iFilesArray.push(ifiles)
                }
            })

            setMapIndividualFiles(iFilesArray)
            setIsLoadedEmb(true)

        })
    }, [])

    useEffect(()=>{
        if(isLoadedEmb && isLoadedIndi) setIsLoaded(true)
    },[isLoadedEmb , isLoadedIndi])

    useEffect(() => {
        if (!isLoaded || mapIndividualFiles.length === 0) return

        const tracks = mapIndividualFiles.map((file) => ({
            type: 'alignment',
            format: 'bam',
            url: `${url}/files/bimfile/${file.bimID}`,
            indexURL: `${url}/files/baifile/${file.baiID}`,
            name: file.individual ? file.individual.fileName : file.embryo?.sampleName
            
        }))

        const options = {
            genome: 'hg38',
            tracks: tracks,
            locus: locus
        }
        igv.createBrowser(igvDivRef.current, options).then((browser: any) => {
            igvBrowserRef.current = browser
          })

    }, [isLoaded])

    useEffect(() => {
        if (variants.length > 0 ){
            let aux: MutationsPosition[] = []

            variants.sort((a,b)=> Order[a.paternal]- Order[b.paternal]).forEach(v => {
                if(filterVariant(v)) aux.push(v)
            })
           
              if (igvBrowserRef.current) {
                  igvBrowserRef.current.search(locus)
              }
            
            setSelectedVarinat(aux[0])
          
        }
    },[props.variants])

    useEffect(() => {
        if (props.externalLocus && igvBrowserRef.current) {
            igvBrowserRef.current.search(props.externalLocus)
            setLocus(props.externalLocus)
        }
    }, [props.externalLocus])

    useEffect(()=>{
        if (!selectedVariant) return

        const newLocus = selectedVariant.type === "SNP"
          ? `${selectedVariant.chromosome}:${selectedVariant.position}`
          : `${selectedVariant.chromosome}:${selectedVariant.start}-${selectedVariant.end}`
      
        setLocus(newLocus)
      
        if (igvBrowserRef.current) {
          igvBrowserRef.current.search(newLocus)
        }

        let both: MutationsPosition | undefined = undefined
        let list: DirectTesting[]
        variants.sort((a,b)=> Order[a.paternal]- Order[b.paternal]).forEach(v => {
            if(selectedVariant.description === v.description && 
                ((selectedVariant.type === "SNP" && selectedVariant.position === v.position) ||
                (selectedVariant.start === v.start && selectedVariant.end === v.end)) &&
                selectedVariant.paternal !==  v.paternal 
            ) {
               both = v
            }
            })
  
        if (both) {
            setIsBoth(true)
            directDetectionService.getByMutationID(selectedVariant.id).subscribe(res => {
                list = res.items

                directDetectionService.getByMutationID(both?.id || "").subscribe(res2 => {
                   
                    list.forEach((l,i)=>{

                        res2.items.forEach(r2 =>{
                            if(!list.some(find => find.individualID === r2.individualID)) list.push(r2)
                                else if(l.individualID === r2.individualID && l.status !== r2.status){
                                if (r2.status === Status.Carrier) list[i] = r2
                                    
                            }  
                        })
                    })
                    setIndividualsDir(list)
                })
              })
        } else {
            setIsBoth(false)
            directDetectionService.getByMutationID(selectedVariant.id).subscribe(res => {
                setIndividualsDir(res.items)
              })
      
        }

        
      
    },[selectedVariant])


    const handleSelectedVariant = (id: string) => {
        const variantAux = variants.sort((a,b)=> Order[a.paternal]- Order[b.paternal]).find(v => v.id === id)
        if (variantAux) {
          setSelectedVarinat(variantAux)
        }
    }

    const sortedEmbryoRows = useMemo(() => {
        if (embryos.length === 0 || individualsDir.length === 0) return [] as Array<{ emb: DirectTesting; originalIndex: number }>

        const rows: Array<{ emb: DirectTesting; originalIndex: number; name: string }> = []

        individualsDir.forEach((emb, idx) => {
            const e = embryos.find(i => i.id === emb.individualID)
            if (e) {
                rows.push({ emb, originalIndex: idx, name: e.sampleName || '' })
            }
        })

        rows.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }))

        return rows.map(({ emb, originalIndex }) => ({ emb, originalIndex }))
    }, [individualsDir, embryos])

    const handleChangeDirectSrarus = (index: number, status: DirectTestingStatus) => {
        let auxIndividuals: DirectTesting[] = [...individualsDir]
        auxIndividuals[index].directTesting = status

        let both = selectedVariant
        variants.sort((a,b)=> Order[a.paternal]- Order[b.paternal]).forEach(v => {
            if(selectedVariant && selectedVariant.description === v.description && 
                ((selectedVariant.type === "SNP" && selectedVariant.position === v.position) ||
                (selectedVariant.start === v.start && selectedVariant.end === v.end)) &&
                selectedVariant.paternal !==  v.paternal 
            ) {

               both = v
            }
            })



       
               if (both && both !== selectedVariant ) {
       
                   let updateAux: DirectTesting | undefined
                   directDetectionService.getByMutationID(both?.id).subscribe(res => {
                       if (res){
                           updateAux = res.items.find( ind => ind.individualID ===   auxIndividuals[index].individualID)
                           if (updateAux){
                               updateAux.directTesting = status
                               directDetectionService.update(updateAux.toDTO()).subscribe(res=>{
                                   if (selectedVariant){
                                   directDetectionService.getByMutationID(selectedVariant?.id).subscribe(res => {
                                               if (res){
                                                   updateAux = res.items.find( ind => ind.individualID ===   auxIndividuals[index].individualID)
                                                   if (updateAux){
                                                       updateAux.directTesting = status
                                                       directDetectionService.update(updateAux.toDTO())
                                                   }
                                                   }
                                           })}
                               })
                           }
                           }
                   })
               }

        setIndividualsDir(auxIndividuals)
        directDetectionService.update(auxIndividuals[index].toDTO())
    }

    const filterVariant = (variant: MutationsPosition) => {
        let check: boolean = true
        if(variant.type !== "SNP"){
            check = !((variant.end - variant.start) > 15)
        }

        if(variant.paternal === "father"){    
            variants.sort((a,b)=> Order[a.paternal]- Order[b.paternal]).forEach(v => {
            if(variant.description === v.description && 
                ((variant.type === "SNP" && variant.position === v.position) ||
                (variant.start === v.start && variant.end === v.end)) &&
                variant.paternal !==  v.paternal 
            ) {
                check = false
            }
            })
        }
        return check
    }

    return isLoaded ? (
        <div style={{width: "100%", height: "100"}} >   
            {!props.hideControls && (
                <Typography
                        style={{
                            fontSize: '17px',
                            fontWeight: 'bold',
                            color: 'rgb(125, 191, 220)',
                            marginBottom: '0.5%',
                            
                        }}
                        align="left">
                        {props?.project?.name}
                    </Typography>
            )}
           {!props.hideControls && (
               <div  style={{display: 'flex',
                            justifyContent: 'center'}}>
                  {variants?.length > 0 &&(
                 <Select
                    variant="outlined"
                    id="variantPosition"
                    style={{
                        textAlign: 'center', 
                        width: '50%',
                        height: '40px',
                        marginTop: '20px',
                        marginBottom: '20px',

                    }}
                    defaultValue={"Select Variant"}
                    value={selectedVariant?.id || ''}
                    onChange={(event) => handleSelectedVariant(event.target.value as string)}
                >
                     <MenuItem value="" disabled hidden>
                        <em>Select variant</em>
                    </MenuItem>
                   {variants.sort((a,b)=> Order[a.paternal]- Order[b.paternal]).map(element => (
                      filterVariant(element) && <MenuItem value={element.id}>{element.description}</MenuItem>
                   ))}
                </Select>
             )}
                </div>
           )}
            <div style={{display: "flex", flexDirection: "row"}} >
                {!props.hideControls && (
                    <div
                        style={{
                            width: "50%",
                            position: "sticky",
                            top: 75,
                            zIndex: 1000,
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            paddingRight: "20px" 
                    }}>
                        
                        <TableContainer className={styles2.hideScrollbar} >

                            <Table  size="small" >
                                <Head
                                    fields={fields}
                                    styleHeader={{fontWeight: 'bold', color: 'rgb(125, 191, 220)'}}
                                />
                                <Body fields={fields} items={[]} rowKeyField={''}/>
                                {individualsDir.map((ind, i) => (
                                individuals.find(i=> i.id === ind.individualID) && <TableRow>
                                        <TableCell key="individual" className={styles.selectCell}>
                                            {individualsTitle()[individuals.find(i=> i.id === ind.individualID)?.individual ?? 7]}
                                        </TableCell>
                                         <TableCell key='fileName'  className={styles.selectCell} >
                                           { individuals?.find(i=> i.id === ind.individualID)?.fileName}
                                        </TableCell> 
                                        <TableCell key="status" className={styles.selectCell}>
                                            {statusTitle()[ind.status]}
                                        </TableCell>
                                        <TableCell 
                                        >
                                        <Select
                                            variant="outlined"
                                            id="direcStatus"
                                            key="selectIndividual"
                                            value={ind.directTesting}
                                            style={{width: "100%"}}
                                            renderValue={(value) =>
                                                value ? (
                                                directTestingStatusTitle()[value as DirectTestingStatus]
                                                ) : (
                                                <em>{directTestingStatusTitle()[DirectTestingStatus.Status]}</em>
                                                )
                                            }
                                            disabled={(props.step === 2  && ind.directTesting !== DirectTestingStatus.Status)}
                                            className={ind.directTesting !== 0? styles2.directTestSelected : styles2.directTestStatus}
                                            onChange={(event) => handleChangeDirectSrarus(i ,event.target.value as DirectTestingStatus)}>
                                            {directTestingOptions.map(dt => (
                                            ( dt ===3 && isBoth &&   individuals.find(i=> i.id === ind.individualID)?.individual === 3 ) ||
                                            (dt !== 3 )
                                            ) &&<MenuItem value={dt}>{directTestingStatusTitle()[dt]}</MenuItem>)}
                                                
                                            </Select> 
                                    </TableCell>
                                    </TableRow>
                                ))}
                            </Table>
                        </TableContainer>

                        {props.step === 2 && embryos.length > 0 && (
                            <TableContainer className={styles2.hideScrollbar}>
                            <Table  size="small" >
                                <Head
                                    fields={fields2}
                                    styleHeader={{fontWeight: 'bold', color: 'rgb(125, 191, 220)'}}
                                />
                                <Body fields={fields2} items={[]} rowKeyField={''}/>
                                {sortedEmbryoRows.map(({ emb, originalIndex }) => (
                                 embryos.find(i=> i.id === emb.individualID) && <TableRow>
                                        <TableCell key="individual" className={styles.selectCell}>
                                        {embryos.find(i=> i.id === emb.individualID)?.sampleName}
                                        </TableCell>
                                        <TableCell key='fileName'  className={styles.selectCell} >
                                           { embryos?.find(i=> i.id === emb.individualID)?.fileName}
                                        </TableCell> 
                                        <TableCell 
                                        >
                                           <Select
                                            variant="outlined"
                                            id="direcStatus"
                                            key="selectEmbryo"
                                            style={{width: "100%"}}
                                            value={emb.directTesting}
                                            renderValue={(value) =>
                                                value ? (
                                                  directTestingStatusTitle()[value as DirectTestingStatus]
                                                ) : (
                                                  <em>{directTestingStatusTitle()[DirectTestingStatus.Status]}</em>
                                                )
                                              }
                                            className={emb.directTesting !== 0 ? styles2.directTestSelected : styles2.directTestStatus}
                                            onChange={(event) => handleChangeDirectSrarus(originalIndex ,event.target.value as DirectTestingStatus)}
                                            >
                                            {directTestingOptions.map(dt => ((dt === 3 && isBoth) ||dt!==3 ) &&<MenuItem value={dt}>{directTestingStatusTitle()[dt]}</MenuItem>)}
                                                
                                            </Select> 
                                       </TableCell>
                                    </TableRow>
                                ))}
                            </Table>
                        </TableContainer>
                    )}
                    </div>
                )}
                    <div style={{width: props.hideControls ? "100%" : "50%", minHeight: "650px"}} ref={igvDivRef} />
            </div>
                {!props.hideControls && (
                    <Button
                        variant="contained"
                        onClick={() => props.setViewIGV(false)}
                        className={styles2.button}
                        style={{ marginBottom: '20px' }}
                    >
                            {t('back')}
                        </Button>
                )}
        </div>
    ) :  <div className={styles.modalLoading}>
            <CircularProgress className={styles.circularProgress}/>
        </div>
}